import React from "react";
import { lazyWithRetry } from "utils/lazy-with-retry";

const LazyEditAssessment = lazyWithRetry(() => import("./EditAssessment"));

const EditAssessment = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode },
) => <LazyEditAssessment {...props} />;

export default EditAssessment;
